import React from 'react';
import ContentLoader from 'react-content-loader'

import { getLoaderColors } from '../../utils/theme';

import ThemeContext from '../../context/ThemeContext';

const Placeholder = props => {
    return (
        <ThemeContext.Consumer>
            {
                ({ theme }) => (
                    <div className="modal-wrap placeholder">
                        <div className="modal-overlay" />

                        <div className="modal-wrap-inner">
                            <div className="modal modal-default">
                                <div className="modal-main">
                                    <div className="modal-inner">
                                        <div className="modal-header">
                                            <ContentLoader width="520" height="36" style={{width: '100%', height: '36px'}} animate={!props.static} primaryColor={getLoaderColors(theme).primary} secondaryColor={getLoaderColors(theme).secondary}>
                                                <rect x="0" y="12" rx="6" ry="6" width="250" height="12" />
                                            </ContentLoader>
                                        </div>

                                        <div className="modal-body">
                                            <ContentLoader width="520" height="400" style={{width: '100%', height: '400px'}} animate={!props.static} primaryColor={getLoaderColors(theme).primary} secondaryColor={getLoaderColors(theme).secondary}>
                                                <rect x="0" y="12" rx="4" ry="4" width="400" height="8" />
                                                <rect x="0" y="32" rx="4" ry="4" width="320" height="8" />
                                                <rect x="0" y="52" rx="4" ry="4" width="280" height="8" />
                                            </ContentLoader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </ThemeContext.Consumer>
    )
}

export default Placeholder;
